import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  constructor() {}

  addUIPollsPropertiesToMatches(matches: any[], polls: any[], user: any) {
    matches.map((match: any) => {
      match.stats = {
        homeWin: 0,
        homeWinUsers: [],
        awayWin: 0,
        awayWinUsers: [],
        draw: 0,
        drawUsers: [],
        jokers: 0,
        jokersUsers: [],
        scoreResults: [],
      };
      const scoreResultsByLabel = new Map<string, any>();

      polls.forEach((poll: any) => {
        if (!poll.user) {
          return;
        }

        const result = poll.results.find(
          (result: any) => result.match._id === match._id
        );

        if (!result) {
          return;
        }

        const participant = this.buildParticipantWithPrediction(
          poll.user,
          match,
          result,
        );

        if (
          Number.isInteger(result.homeGoals) &&
          Number.isInteger(result.awayGoals)
        ) {
          const scoreLabel = this.getScoreResultLabel(match, result);
          const scoreKey = this.getScoreResultKey(match, result);
          const scoreResult = scoreResultsByLabel.get(scoreKey) ?? {
            label: scoreLabel,
            winnerTeam: this.getScoreResultWinnerTeam(match, result),
            count: 0,
            users: [],
          };
          scoreResult.count += 1;
          scoreResult.users.push(participant);
          scoreResultsByLabel.set(scoreKey, scoreResult);
        }

        const predictedWinner = this.getPredictedWinner(match, result);

        if (predictedWinner === 'DRAW') {
          match.stats.draw += 1;
          match.stats.drawUsers.push(participant);
        } else if (predictedWinner === match.homeTeam?._id) {
          match.stats.homeWin += 1;
          match.stats.homeWinUsers.push(participant);
        } else if (predictedWinner === match.awayTeam?._id) {
          match.stats.awayWin += 1;
          match.stats.awayWinUsers.push(participant);
        }

        if (poll.user.jokers?.matches?.includes(match._id)) {
          match.stats.jokers += 1;
          match.stats.jokersUsers.push(participant);
        }

        if (poll.user._id === user._id) {
          match.userHomeGoals = result.homeGoals;
          match.userAwayGoals = result.awayGoals;
          match.useJoker = user.jokers.matches.includes(match._id);
        }
      });

      match.stats.scoreResults = Array.from(scoreResultsByLabel.values()).sort(
        (left, right) =>
          right.count - left.count || left.label.localeCompare(right.label, 'es'),
      );
    });

    return matches;
  }

  private getPredictedWinner(match: any, result: any): string | null {
    if (result.homeGoals === result.awayGoals) {
      if (match.round === 'GROUP_STAGE') {
        return 'DRAW';
      }

      return this.getWinnerId(result.penaltiesWinner);
    }

    return result.homeGoals > result.awayGoals
      ? (match.homeTeam?._id ?? null)
      : (match.awayTeam?._id ?? null);
  }

  private getWinnerId(winner: any): string | null {
    if (!winner) return null;
    return typeof winner === 'string' ? winner : (winner._id ?? null);
  }

  private buildParticipantWithPrediction(
    user: any,
    match: any,
    result: any,
  ): any {
    return {
      ...user,
      prediction: {
        label: this.getScoreResultLabel(match, result),
        winnerTeam: this.getScoreResultWinnerTeam(match, result),
      },
    };
  }

  private getScoreResultLabel(match: any, result: any): string {
    return `${result.homeGoals}-${result.awayGoals}`;
  }

  private getScoreResultKey(match: any, result: any): string {
    const score = this.getScoreResultLabel(match, result);
    if (
      match.round !== 'GROUP_STAGE' &&
      result.homeGoals === result.awayGoals &&
      result.penaltiesWinner
    ) {
      return `${score}:${this.getWinnerId(result.penaltiesWinner)}`;
    }

    return score;
  }

  private getScoreResultWinnerTeam(match: any, result: any): any | null {
    if (
      match.round !== 'GROUP_STAGE' &&
      result.homeGoals === result.awayGoals &&
      result.penaltiesWinner
    ) {
      const winnerId = this.getWinnerId(result.penaltiesWinner);
      return winnerId === match.homeTeam?._id ? match.homeTeam : match.awayTeam;
    }

    return null;
  }
}
